import { FC, useState } from "react";
import { Collapse } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "go-core/components/useWindowSize";
import { ReactComponent as CollapseSVG } from "go-core/images/svg/actions/collapse.svg";
import {
	AddonApi,
	SubscriptionApi,
	UpdateAddonApi,
	UpdateSubscriptionsApi,
} from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { PriceConfiguratorAddonApi } from "../../../../../../../../services/Api/types";
import InstalledAddon from "./InstalledAddon";
import UninstalledAddon from "./UninstalledAddon";

interface Props {
	index: number;
	fields: UpdateAddonApi[];
	form: UseFormReturn<UpdateSubscriptionsApi>;
	estimate?: SubscriptionApi;
	configAddons?: PriceConfiguratorAddonApi[];
	handleRemove: (add: AddonApi, index: number) => void;
	handleAdd: (addon: PriceConfiguratorAddonApi, skipRules?: boolean) => void;
	editable: boolean;
	estimating: boolean;
}

const MonthlyAddons: FC<Props> = (props: Props) => {
	const [collapseOpen, setCollapseOpen] = useState(true);
	const { t } = useTranslation();
	const watchedFields = props.fields;
	const isSmallBreakpoint = useWindowSize().isSmallBreakpoint;

	const onCollapse = () => {
		setCollapseOpen(!collapseOpen);
		const icon = document.getElementById(`${props.estimate?.plan_id}-collapse-icon-monthly`);
		if (icon) {
			icon.style.transform = !collapseOpen ? "rotate(180deg)" : "";
		}
	};

	return (
		<div className={"addons-container"}>
			<div className={"title"} onClick={() => onCollapse()}>
				<h5>{t("modules.subscription.field.monthly_addons.title")}</h5>
				<CollapseSVG className={"collapse-icon"} id={`${props.estimate?.plan_id}-collapse-icon-monthly`} />
			</div>
			<Collapse in={collapseOpen}>
				<div>
					{!isSmallBreakpoint && (
						<div className={"row"}>
							<label className={"w-60 form-label"}>{t("lib:common.word.name")}</label>
							<label className={"w-15 form-label"}>
								{t("modules.subscription.field.quantity.title")}
							</label>
							<label className={"w-15 form-label"}>
								{t("modules.subscription.field.total_price.title")}
							</label>
						</div>
					)}
					{watchedFields?.map((addon, addIndex) => {
						// let add = props.estimate?.addons.find(x => x.addon_id == addon.addon_id) as AddonApi;
						const estimateAddon = props.estimate?.monthly_sub_item?.addons.find(
							(x) => x.addon_id === addon.addon_id
						) as AddonApi;
						const configAddon = props.configAddons?.find(
							(f) => f.addon_id === addon.addon_id
						) as PriceConfiguratorAddonApi;
						return (
							<InstalledAddon
								configAddon={configAddon}
								index={addIndex}
								addonIndex={`subscriptions.${props.index}.monthly_sub_item.addons`}
								form={props.form}
								handleRemove={(add) => props.handleRemove(add, addIndex)}
								estimateAddon={estimateAddon}
								key={`${addon.addon_id}-monthly`}
								monthly={true}
								estimating={props.estimating}
							/>
						);
					})}
					{props.configAddons?.map((addon, index) => {
						let alreadyInstalled = false;
						watchedFields?.forEach((add) => {
							if (add.addon_id === addon.addon_id) {
								alreadyInstalled = true;
							}
						});
						if (!alreadyInstalled && props.editable) {
							return (
								<UninstalledAddon
									handleAdd={props.handleAdd}
									addon={addon}
									key={`${addon.addon_id}-monthly`}
								/>
							);
						}
						return null;
					})}
				</div>
			</Collapse>
		</div>
	);
};
export default MonthlyAddons;
